import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHydroquinoneGlyphSecondary from './svgs/HydroquinoneGlyphSecondary.js';
import SvgHydroquinoneGlyph from './svgs/HydroquinoneGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var hydroquinoneGlyph = (props => useIcon(SvgHydroquinoneGlyph, SvgHydroquinoneGlyphSecondary, props));

export { hydroquinoneGlyph as default };
